import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class CountryAttendanceOnline extends SeoHeadingHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const attendanceSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const onlyCountryAndAttendanceSelected = await this.selectionOnlyFor([FilterKey.COUNTRY, FilterKey.DELIVERY_METHOD], filterSelectionState);

		return metaRankingSortSelected
			&& onlyCountryAndAttendanceSelected
			&& attendanceSelected
			&& countrySelected
			&& attendance === AttendanceFilterOptionValue.ONLINE;
	}

	protected selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);

		const seoInfo = `Leading Universities in ${country} with Online Programmes`;

		return Promise.resolve(seoInfo);
	}
}
